__turbopack_context__.v({
  "empty": "IconButton-module__3bHq5q__empty",
  "filled": "IconButton-module__3bHq5q__filled",
  "main": "IconButton-module__3bHq5q__main",
  "outlined": "IconButton-module__3bHq5q__outlined",
  "rounded": "IconButton-module__3bHq5q__rounded",
  "selected": "IconButton-module__3bHq5q__selected",
  "square": "IconButton-module__3bHq5q__square",
});
